import React, { useEffect, useState } from "react";
import {
  Table, TableBody, TableCell, TableHead, TableRow,
  Checkbox, Button, TextField, Typography, Box, Divider, TableContainer, Tooltip, Grid, Toolbar, useTheme, Dialog, DialogTitle, DialogContent
} from "@mui/material";
import { tokens } from "../../../theme/theme";
import Header from "../../../Layout/Header";
import AddNewPurchaseOrder from "../order/AddPurchaseOrder";
import CustomTableContainer from "../../../Layout/CustomTableContainer";

const calculateScore = (quoted_price, delivery_date, payment_terms) => {
  const deliveryDays = (new Date(delivery_date) - new Date()) / (1000 * 3600 * 24);
  const priceScore = (1 / quoted_price) * 50;
  const deliveryScore = deliveryDays > 0 ? (1 / deliveryDays) * 30 : 0;
  const paymentScore = (payment_terms / 30) * 20;
  return (priceScore + deliveryScore + paymentScore).toFixed(2);
};

const CompareQuotations = ({ handlecallback, quotationData, selectedRequestIndentNumberList, selectedVendoIdListID }) => {
  const [selectedVendors, setSelectedVendors] = useState({});
  const [poPreviewOpen, setPoPreviewOpen] = useState(false);
  const [vendorGroupedPOs, setVendorGroupedPOs] = useState({});

  const [vendorCompare, setVendorCompare] = useState(true);
  const [purchase_order, setPurchase_order] = useState(false);

  const [selectedVendorForPO, setSelectedVendorForPO] = useState([]);
  const [purchase_indent_no, setpurchase_indent_no] = useState('');
  const [globalSelectedVendor, setGlobalSelectedVendor] = useState(null);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);


  const handleSelect = (material_code, party_name, quantity, row) => {
    setSelectedVendors(prev => {
      const updated = { ...prev };

      const requiredQty = row.quantity_required;
      const newTotal = quantity;

      if (newTotal > requiredQty) {
        alert(`Total quantity for ${material_code} cannot exceed ${requiredQty}. You are trying to assign ${newTotal}.`);
        return prev; // prevent over-assign
      }

      if (quantity > 0) {
        updated[material_code] = [{ ...row, selectedQty: quantity }];
        setGlobalSelectedVendor(party_name);
      } else {
        delete updated[material_code];

        // If no other row is using this vendor, clear global vendor
        const isStillUsed = Object.values(updated).some(entries =>
          entries.some(e => e.party_name === party_name)
        );
        if (!isStillUsed) setGlobalSelectedVendor(null);
      }

      return updated;
    });
  };

  useEffect(() => {
    if (selectedRequestIndentNumberList) {
      setpurchase_indent_no(selectedRequestIndentNumberList.request_indent_number);
    }
  }, [selectedRequestIndentNumberList]);

  const getRemainingQty = (material_code) => {
    const assigned = selectedVendors[material_code]?.reduce((sum, v) => sum + (v.selectedQty || 0), 0) || 0;
    const requiredQty = quotationData.find(q => q.material_code === material_code)?.quantity_required || 0;
    return requiredQty - assigned;
  };

  const generatePOs = () => {
    const vendorGrouped = {};
    Object.values(selectedVendors).flat().forEach(item => {
      if (!vendorGrouped[item.party_name]) vendorGrouped[item.party_name] = [];
      vendorGrouped[item.party_name].push(item);
    });
    setVendorGroupedPOs(vendorGrouped);
    setPoPreviewOpen(true);
  };

  const generatePartyWisePOs = (vendor, items) => {
    console.log("Generating PO for:", vendor);
    console.table(items); // Full details per vendor
    // You can also trigger your PO creation logic here using 'items'
    // , cgst_rate: 0.0, cgst_amount: 0.0, sgst_rate: 0.0, sgst_amount: 0.0, igst_rate: 0.0, igst_amount: 0.0, additional_info: '', total: 0.0
    if (items && items.length > 0) {
      const enrichedItems = items.map((item) => ({
        ...item,
        cgst_rate: 0.0,
        cgst_amount: 0.0,
        sgst_rate: 0.0,
        sgst_amount: 0.0,
        igst_rate: 0.0,
        igst_amount: 0.0,
        additional_info: '',
        total: 0.0,
      }));

      setSelectedVendorForPO(enrichedItems);  // <-- Use the enriched items here
    }

    //setSelectedVendorForPO(items);

    setVendorCompare(false);
    setPurchase_order(true);
  };


  const groupedMaterialCodes = [...new Set(quotationData.map(q => q.material_code))];
  const callback = () => handlecallback();



  useEffect(() => {

    if (quotationData.length > 0) {
      const materialCodes = [...new Set(quotationData.map(q => q.material_code))];
      setSelectedVendors(materialCodes.reduce((acc, code) => ({ ...acc, [code]: [] }), {}));
    }
  }, [quotationData]);

  return (

    <>

      {vendorCompare && (
        <Box >
          <Header title='Compare & Choose Vendor Quotations' subtitle="" callback={callback} />
          <Divider />

          {groupedMaterialCodes.map(material_code => {
            const materialRows = quotationData.filter(q => q.material_code === material_code);
            const remainingQty = getRemainingQty(material_code);

            return (
              <Box key={material_code} p={2} sx={{ mb: 2, p: 2 }}>
                <Box
                  sx={{
                    // border: `1px solid ${colors.grey[400]}`, // You can adjust color or use a hex
                    // borderRadius: '8px',
                    //  padding: '4px 8px', 
                    ml: 1,
                  }}
                >
                  <Typography fontWeight={'bold'} variant="h6" gutterBottom>
                    {material_code} - {materialRows[0]?.material_description}
                  </Typography>
                </Box>



                <CustomTableContainer colors={colors}>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Select</TableCell>
                          <TableCell>Vendor</TableCell>
                          <TableCell>Quoted Price</TableCell>
                          <TableCell>Delivery Date</TableCell>
                          <TableCell>Payment Term</TableCell>
                          <TableCell>Required Quantity</TableCell>
                          <TableCell>Remaining Qty</TableCell>
                          <TableCell>Vendor Assign Quantity</TableCell>
                          <TableCell>Score</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {materialRows.map((row, index) => {
                          const score = calculateScore(row.quoted_price, row.delivery_date, row.payment_terms);
                          const existing = selectedVendors[material_code]?.[0];
                          const isChecked = existing?.party_name === row.party_name;

                          const isDisabled =
                            globalSelectedVendor !== null && globalSelectedVendor !== row.party_name;

                          return (
                            <TableRow key={index}>
                              <TableCell>
                                <Tooltip title={isDisabled ? "Only one vendor can be selected globally" : "Select vendor"}>
                                  <span>
                                    <Checkbox
                                      color="secondary"
                                      checked={isChecked}
                                      disabled={isDisabled}
                                      onChange={() => {
                                        if (isChecked) {
                                          handleSelect(material_code, row.party_name, 0, row);
                                        } else {
                                          handleSelect(material_code, row.party_name, row.quantity_required, row);
                                        }
                                      }}
                                    />
                                  </span>
                                </Tooltip>
                              </TableCell>
                              <TableCell>{row.party_name}</TableCell>
                              <TableCell>{row.quoted_price}</TableCell>
                              <TableCell>{row.delivery_date}</TableCell>
                              <TableCell>{row.payment_terms}</TableCell>
                              <TableCell>{row.quantity_required}</TableCell>
                              <TableCell>{getRemainingQty(material_code)}</TableCell>
                              <TableCell>
                                <TextField
                                  type="number"

                                  placeholder="0"

                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  value={isChecked ? existing?.selectedQty : ''}
                                  onChange={(e) => {
                                    const qty = parseInt(e.target.value || 0);
                                    handleSelect(material_code, row.party_name, qty, row);
                                  }}
                                  inputProps={{ style: { textAlign: 'right' }, min: 0, max: row.quantity_required }}
                                  disabled={!isChecked}


                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      '& fieldset': {
                                        border: 'none',  // Removes the border
                                      },
                                      backgroundColor: 'transparent', // Optional: remove background color if needed

                                    },
                                  }}
                                />
                              </TableCell>
                              <TableCell>{score}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>

                    </Table>
                  </TableContainer>
                </CustomTableContainer>
              </Box>
            );
          })}




          <Dialog open={poPreviewOpen} onClose={() => setPoPreviewOpen(false)} maxWidth="md" fullWidth>
            <DialogTitle>Vendor-wise PO Preview</DialogTitle>
            <DialogContent>
              {Object.keys(vendorGroupedPOs).map(vendor => (
                <Box key={vendor} sx={{ mb: 3 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{vendor}</Typography>
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={() => generatePartyWisePOs(vendor, vendorGroupedPOs[vendor])}
                    >
                      Generate PO
                    </Button>

                  </Box>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Material Code</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Price</TableCell>
                        <TableCell>Delivery Date</TableCell>
                        <TableCell>Payment Terms</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {vendorGroupedPOs[vendor].map((item, idx) => (
                        <TableRow key={idx}>
                          <TableCell>{item.material_code}</TableCell>
                          <TableCell>{item.material_description}</TableCell>
                          <TableCell>{item.selectedQty}</TableCell>
                          <TableCell>{item.quoted_price}</TableCell>
                          <TableCell>{item.delivery_date}</TableCell>
                          <TableCell>{item.payment_terms}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              ))}

            </DialogContent>
          </Dialog>



          <Grid container>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
              <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
                <Toolbar>

                  <Button size="small" variant="contained" onClick={generatePOs} color="secondary" sx={{ marginLeft: 'auto', textTransform: 'none' }}> Generate PO Preview</Button>


                </Toolbar>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}

      {purchase_order && (
        <AddNewPurchaseOrder handlecallback={handlecallback} editPurchaseOrderNumber={0} vendor_details={selectedVendorForPO} purchase_indent_no={purchase_indent_no} selectedVendoIdListID={selectedVendoIdListID} />
      )}



    </>
  );
};

export default CompareQuotations;
